import { axiosApiClient } from "..";
import { handleError } from "../../utils/errors";

const BASE_URL = "/revenue";

class RevenueService {
  getMonthlyRevenueByPeriod = async ({
    startYear,
    startMonth,
    endYear,
    endMonth,
  }) => {
    try {
      const response = await axiosApiClient.get(
        `${BASE_URL}/monthly/period?startYear=${startYear}&startMonth=${startMonth}&endYear=${endYear}&endMonth=${endMonth}`
      );

      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(
        err,
        "Error occurred while fetching monthly revenue by period."
      );
    }
  };

  getMonthlyRevenues = async () => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/monthly`);

      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while fetching monthly revenue.");
    }
  };
}

const revenueService = new RevenueService();
export default revenueService;
